import {Component, ElementRef, HostListener, inject, input, output} from '@angular/core';
import {ImagesService} from '../../../services/general/images.service';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';
@Component({
  selector: 'app-institution-filter',
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './institution-filter.component.html',
  styleUrl: './institution-filter.component.scss'
})
export class InstitutionFilterComponent {
  _images = inject(ImagesService);
  today = new Date().toISOString().split('T')[0];
  isShowFilters: boolean = false;
  isShowInstitutions: boolean = false;
  isShowCategory: boolean = false;
  selectedCategory: string = '--select category--';
  selectedInstitutions: string[] = [];
  isLoading: boolean = false;
  _eref = inject(ElementRef);
  _fb = inject(FormBuilder);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isShowFilters = false;
    }
  }

  onClick() {
    this.isShowFilters = !this.isShowFilters;
  }

  statusOptions = input<{ value: string; label: string }[]>([
    { value: 'Active',   label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
  ]);

  formData: FormGroup = this._fb.group({
    startDate: [''],
    endDate: [''],
    status: [''],
  });

  resetClickEvent = output<void>()
  onResetClick() {
    this.formData.reset({
      startDate: '',
      endDate: '',
      status: null,
    });
    this.resetClickEvent.emit();
  }

  onSaveEvent = output<FormGroup>()
  onSaveFilters() {
    // Check if at least one filter is selected
    this.isShowFilters = false;
    this.onSaveEvent.emit(this.formData);
  }
}
